import { DialogPartManifestJson } from '../../API/DialogJson'
import Video from '../Video/Video'
import DialogOption from './DialogOption'

export default class DialogPart {
    element = document.createElement('div')
    id: string
    loopVideoId: string

    loopVideo?: Video

    optionsContainer = document.createElement('div')
    options: Record<string, DialogOption>

    constructor(manifest: DialogPartManifestJson) {
        this.hide()
        this.id = manifest.id
        this.loopVideoId = manifest.loop

        this.element.classList.add('dialog-part')
        this.optionsContainer.classList.add('dialog-options-container')
        this.element.appendChild(this.optionsContainer)

        this.options = manifest.options.reduce((acc, optionManifest, index) => {
            const option = new DialogOption(index, optionManifest, this)

            this.optionsContainer.appendChild(option.element)

            return {
                ...acc,
                [option.id]: option,
            }
        }, {})
    }

    setLoop = (loop: Video) => {
        this.loopVideo = loop
    }

    start = () => {
        if (this.loopVideo) {
            this.loopVideo.show()
            this.loopVideo.play()
        }

        this.show()
        this.showOptions()
    }

    stop = () => {
        this.hide()

        if (this.loopVideo) {
            this.loopVideo.hide()
            this.loopVideo.pause()
        }
    }

    show = () => {
        this.element.classList.remove('hidden')
    }

    hide = () => {
        this.element.classList.add('hidden')
    }

    hideOptions = () => {
        this.optionsContainer.classList.add('hidden')
    }

    showOptions = () => {
        this.optionsContainer.classList.remove('hidden')
    }

    destroy = () => {
        Object.keys(this.options).forEach((optionId) => {
            this.options[optionId].destroy()
        })
        this.optionsContainer.remove()
        this.element.remove()
    }
}
